import classNames from 'classnames'
import React from 'react'

interface Props {
  spacing?: number
}

export const SectionHeader: React.FC<Props> = ({ spacing = 1, children }) => {
  return (
    <h2 className={classNames('stk-text-h4', `stk-space-out-b-${spacing}`)}>
      {children}
    </h2>
  )
}
